import React from "react";
import $ from "jquery";

import {
  FaQuestion,
  FaRegSun,
  FaCartPlus,
  FaPencilAlt,
  FaPlus,
  FaTrashAlt,
  FaDownload,
} from "react-icons/fa";

export default function Info() {
  return (
    <div>
      <span data-toggle="modal" data-target="#infoModal">
        <button
          className="btn btn-sm btn-outline-warning"
          data-toggle="tooltip"
          data-placement="bottom"
          id="infoIcon"
          onClick={() => $("button").tooltip("hide")}
          title="معلومات"
        >
          <FaQuestion size="1.2em" />
        </button>
      </span>
      <div
        className="modal fade"
        id="infoModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                معلومات عن تطبيق اسهمي
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div id="accordion">
                <div className="card mb-1">
                  <div className="card-header p-1 bg-light" id="headingOne">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        ماهو تطبيق اسهمي؟
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body text-dark">
                      عبارة عن تطبيق ويب لحساب الأرباح والخسائر لعمليات الشراء
                      والبيع في اسواق المال المدخلة من قبل المستخدم. مع عرض اجمالي الأرباح والخسائر
                      للحساب ولكل عملية. يمكن للمستخدم التحكم بنسبة العمولة والضريبة
                    </div>
                  </div>
                </div>
                <div className="card mb-1">
                  <div className="card-header p-1 bg-light" id="headingTwo">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        كيف يعمل تطبيق اسهمي؟
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body text-dark">
                      يعمل التطبيق من خلال اضافة المستخدم لعمليات الشراء البيع
                      التي قام بها وعلى هذا الاساس يتم حساب الارباح والخسائر
                      والفترة الزمنية لهذه العمليات. في حال ان المستخدم قام
                      بإضافة شراء اسهم سيتم اضافتها للاسهم الحالية ، يمكن
                      للمستخدم بعد ذلك اضافة بيع جزء او كامل الاسهم الحالية ، في
                      حال بيع جزء فقط ستبقى العملية في خانة الاسهم الحالية مع
                      اظهار الارباح والخسائر لهذه العملية ، وفي حال بيع كامل
                      الاسهم فيستم نقل العملية للاسهم المكتملة مع ملخص للعملية
                      من الفترة الزمنية والارباح والخسائر واجمالي العمولات ..
                      الخ
                    </div>
                  </div>
                </div>
                <div className="card mb-1">
                  <div className="card-header p-1 bg-light" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        كيف استخدم تطبيق اسهمي؟
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body text-dark">
                      في البداية لكي تظهر لك نسبة الارباح والخسائر والمعلومات
                      كاملة يجب اضافة رصيد للحساب وذلك بالنقر على ايقونة
                      الاعدادات <FaRegSun /> اعلى اليسار ثم اضافة المبلغ ، كما
                      يمكنك تغيير عمولة التداول ونسبة الضريبة وحذف جميع البيانات
                      من نفس النافذة.
                      <br></br>
                      <br></br>
                      لاضافة اسهم انقر على (اضافة اسهم) في اعلى اليسار للاسهم
                      الحالية ستظهر لك نافذة يمكنك من خلالها اضافة شراء اسهم
                      وذلك بإضافة تاريخ الشراء واسم الشركة وعدد الاسهم وسعرها
                      بدون عمولة.
                      <br></br>
                      <br></br>
                      بعد اضافة شراء اسهم ستظهر لك اربع ايقونات للسهم ، وفيما
                      يلي وظيفة كلاً منها : <br></br> <FaCartPlus /> لاضافة
                      عملية بيع للسهم نفسه وبالنقر عليها سيتم فتح نافذة يمكنك من
                      خلالها اضافة تاريخ البيع والكمية والسعر في حال بيع جميع
                      الاسهم فسيتم نقل السهم للاسهم المكتملة.
                      <br></br>
                      <FaPencilAlt /> لتعديل معلومات السهم من تاريخ الشراء او
                      الاسم او الكمية او السعر
                      <br></br>
                      <FaPlus /> لاضافة اسهم للسهم الحالي بسعر مختلف مع حساب
                      متوسط سعر السهم الجديد
                      <br></br>
                      <FaTrashAlt /> لحذف بيانات السهم وجميع العمليات التابعه له
                    </div>
                  </div>
                </div>
                <div className="card mb-1">
                  <div className="card-header p-1 bg-light" id="headingFour">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link text-right collapsed"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        كيف واين يتم تخزين البيانات في تطبيق اسهمي؟
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseFour"
                    className="collapse"
                    aria-labelledby="headingFour"
                    data-parent="#accordion"
                  >
                    <div className="card-body text-dark">
                      يتم تخزين البيانات المدخلة من المستخدم في ذاكرة المتصفح
                      واذا كان هذا الخيار معطل فلن يعمل التطبيق بشكل صحيح ، وفي
                      حال حذف ملفات الانترنت المؤقتة سيتم حذف البيانات المدخلة
                      في التطبيق.
                      <br></br>
                      يمكن للمستخدم حفظ البيانات المدخلة في ملف خارجي وفي اي
                      مكان عن طريق النقر على <FaDownload /> في اعلى اليسار
                      والنقر على حفظ وسوف يتم حفظ البيانات الحالية المدخلة مع
                      ملاحظة انه لايتم حفظ رصيد المحفظة واي تغيير في العمولات.
                      <br></br>
                      ويمكن بعد ذلك رفعها مرة اخرى للتطبيق من نفس النافذة في اي
                      وقت وعلى اي نسخة اخرى من التطبيق في اي جهاز اخر
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
